'use client';

import { useSyncExternalStore } from 'react';

import { overlayStack } from '@/app/components/overlays/core/overlayStack';
import type { OverlayRegistrationProps } from '@/app/components/overlays/core/types';
import { getOverlayRegistryKey } from '@/app/components/overlays/utils/getOverlayRegistryKey';

/**
 * Returns whether the given overlay is currently the top-most active overlay.
 */
export function useOverlayStackStatus(
  props: OverlayRegistrationProps
): boolean {
  const key = getOverlayRegistryKey(props);

  return useSyncExternalStore(
    overlayStack.subscribe,
    () => overlayStack.isTop(key),
    () => false // SSR fallback
  );
}
